import styled from 'styled-components';
import { Layout, Card } from 'antd';

const { Sider, Content } = Layout;

export const StyledLayout = styled(Layout)`
  min-height: calc(100vh - 200px);
  background: #f0f2f5;
`;

export const StyledSider = styled(Sider)`
  background: #fff !important;

  .ant-menu {
    height: 100%;
  }
`;

export const StyledContent = styled(Content)`
  padding: 24px;
  margin: 0;
  background: #f0f2f5;
`;

export const ContentCard = styled(Card)`
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
`;
